import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { renderStructuredContent } from '../../renderContext';
import { ACCORDION_BORDER_RADIUS } from './constants';
import { FAQPageWrapper } from './FAQPageWrapper';
import type { CreditCardsAccordionProps } from './types';
export const CreditCardsAccordion = t0 => {
  const $ = _c(14);
  const {
    props
  } = t0;
  const {
    children,
    accordionType
  } = props;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      border: "1px solid",
      borderColor: "neutral.lighter",
      borderRadius: ACCORDION_BORDER_RADIUS
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== accordionType || $[2] !== children) {
    t2 = renderStructuredContent(children, undefined, {
      CreditCardsAccordionItem: {
        accordionType
      }
    });
    $[1] = accordionType;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Box sx={t1}>{t2}</Box>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const innerContent = t3;
  const t4 = accordionType !== "FAQ" ? 3 : 0;
  let t5;
  if ($[6] !== t4) {
    t5 = {
      pt: 3,
      pb: t4
    };
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== accordionType || $[9] !== innerContent) {
    t6 = accordionType === "FAQ" ? <FAQPageWrapper>{innerContent}</FAQPageWrapper> : innerContent;
    $[8] = accordionType;
    $[9] = innerContent;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <Box sx={t5}>{t6}</Box>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};